import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

import { InputLabel, TextInputContainer } from './styled'
import { ReactComponent as Email } from 'assets/images/login/email.svg'

type TextInputProps = {
  name: string
  label?: string
  placeholder: string
  type?: string
  readOnly?: boolean
  disabled?: boolean
  isEmail?: boolean
  [key: string]: unknown // workaround to accept html attributes
}

export function TextInput({
  name,
  placeholder,
  label,
  type = 'text',
  readOnly,
  disabled,
  isEmail,
  ...rest
}: TextInputProps): JSX.Element {
  const { t } = useTranslation(['validation'])

  const [field, meta] = useField({ name, type })

  return (
    <>
      {!!label && <InputLabel>{label}</InputLabel>}
      <TextInputContainer
        hasError={meta.touched && !!meta.error}
        isEmail={isEmail}
      >
        {!!isEmail && (
          <div className="icon-container">
            <Email />
          </div>
        )}
        <input
          id={name}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          type={type}
          {...field}
          {...rest}
          tabIndex={readOnly || disabled ? -1 : 0}
        />
        {meta.touched && !!meta.error && (
          <p>
            {t(`validation:${meta.error}`, {
              field: placeholder
            })}
          </p>
        )}
      </TextInputContainer>
    </>
  )
}
